<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>远程预付费</el-breadcrumb-item>
			<el-breadcrumb-item>终端用户管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search" @submit.native.prevent>
      <el-form-item label="搜索：">
      <el-input placeholder="请输入房间编号" @keyup.enter.native="search" v-model="formInline.meterPointName" size="small"></el-input>
      </el-form-item>
      <el-form-item v-if="user.username == 'admin'">
      	<el-select v-model="getJZ" placeholder="请选择" @change="handleNodeClick" size="small">
      	   <el-option
      	     v-for="item in treeDate"
      	     :key="item.id"
      	     :label="item.departmentName"
      	     :value="item.id">
      	   </el-option>
      	 </el-select>
      </el-form-item>

			<el-form-item >
				<el-input placeholder="请输入用户账号" @keyup.enter.native="search" v-model="formInline.username" size="small"></el-input>
			</el-form-item>
			<el-form-item >
				<el-input placeholder="请输入手机号码" @keyup.enter.native="search" v-model="formInline.phoneNumber" size="small"></el-input>
			</el-form-item>

			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<prems-button size="small" type="primary" icon="el-icon-circle-plus-outline" perms="cuser:add" @click="handleEdit"
				 label="添加" />
			</el-form-item>

			<el-form-item>
				<el-upload action="" multiple :http-request="importData" :show-file-list="false" style="float: left;">
					<prems-button type="success" size="small" icon="el-icon-upload2" perms="cuser:import" :loading="loadLoadin" label="导入" />
				</el-upload>
				<el-button size="small" type="success"   style="margin-left: 10px;"  icon="el-icon-download" :loading="downloadLoadin" @click="exportdata">导出</el-button>
			</el-form-item>
		</el-form>

		<!--列表-->
		<el-table size="small" :data="listData" @selection-change="handleSelectionChange" :header-cell-style="this.$store.state.headerCss" :max-height="tableHeight" highlight-current-row v-loading="loading"
		 border element-loading-text="拼命加载中" style="width: 100%;" stripe>
			<el-table-column align="center" type="selection" width="60">
			</el-table-column>
      <el-table-column  label="房间编号"  >
       	<template slot-scope="scope" >
       		<el-tag size="mini" v-for="item in scope.row.meterInfoVoList" :key="item.id">{{item.meterPointName}}</el-tag>

       	</template>
      </el-table-column>
			<el-table-column prop="username" label="用户账号">
			</el-table-column>
			<el-table-column prop="phoneNumber" label="手机号码"  >
			</el-table-column>


			<el-table-column  label="用户类型" show-overflow-tooltip >
				<template slot-scope="scope" v-if="scope.row.appletUserType">
					<el-tag size="mini" v-if="scope.row.appletUserType == '1'" type="warning">业主</el-tag>
					<el-tag size="mini" v-if="scope.row.appletUserType == '2'" >租户</el-tag>
				</template>
			</el-table-column>
      <el-table-column  label="是否发送短信"  >
      	<template slot-scope="scope" >
      		<el-tag size="mini" v-if="scope.row.isSendMsg == 1"  >是</el-tag>
      		<el-tag size="mini" v-if="scope.row.isSendMsg == 0"  type="danger">否</el-tag>
      	</template>
      </el-table-column>

			<el-table-column prop="createDate" label="创建时间" show-overflow-tooltip >
			</el-table-column>


			<el-table-column align="center" label="操作" width="180">
				<template slot-scope="scope">
					<!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
					<prems-button size="mini" @click="handleEdit(scope.$index, scope.row)" perms="cusr:detail" label="编辑" />

					<!-- <el-button size="mini" type="danger" @click="deleteInfo(scope.$index, scope.row)">删除</el-button> -->
					<prems-button size="mini" type="danger"  perms="cuser:delete" @click="deleteInfo(scope.$index, scope.row)" label="删除" />

				</template>
			</el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination v-bind:child-msg="pageparm" @callFather="callFather" v-if="showPage"></Pagination>


		<el-dialog :title="title" :visible.sync="editFormVisible" width="35%" @click="closeDialog" :close-on-click-modal="false">
			<el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
				<el-form-item label="用户账号" prop="username">
					<el-input size="small" v-model="editForm.username" auto-complete="off" placeholder="请输入用户账号"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="phoneNumber">
					<el-input size="small" v-model="editForm.phoneNumber" auto-complete="off" placeholder="请输入联系电话"></el-input>
				</el-form-item>
				<el-form-item label="用户类型" prop="appletUserType"  size="small" >
					<el-select placeholder="请选择用户类型" v-model="editForm.appletUserType">
						<el-option label="业主" value="1"></el-option>
						<el-option label="租户" value="2"></el-option>
					</el-select>
				</el-form-item>
        <el-form-item label="是否发送短信"  size="small" >
        	<el-select placeholder="请选择用户类型" v-model="editForm.isSendMsg">
        		<el-option label="发送" :value="1"></el-option>
        		<el-option label="不发送" :value="0"></el-option>
        	</el-select>
        </el-form-item>

        <el-form-item v-if="user.username == 'admin'" label="所属部门">
        	<el-select v-model="editForm.departmentId" placeholder="请选择"  size="small">
        	   <el-option
        	     v-for="item in treeDate"
        	     :key="item.id"
        	     :label="item.departmentName"
        	     :value="item.id">
        	   </el-option>
        	 </el-select>
        </el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDialog">取消</el-button>
				<el-button size="small" type="primary" :loading="setLoading" class="title" @click="submitForm('editForm')">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Pagination from '../../components/Pagination'
	import PremsButton from "@/views/permission/PreButtom";
	import {
		appletUserAdd,
		findAllMeterInfoList,
		poiAppletUserList,
		appletUserList,
		appletUserDelete,
		appletUserUpdate,
		uploadAppletUser,
		findMybdMeterInfoList
	} from '../../api/payMG.js'

  import { getDepartmentTerminalInfoLis,getTerminalInfoByDepId } from '../../api/energyMG'
	export default {
		data() {
			 var validatePass = (rule, value, callback) => {

				if (this.selectDatas.length === 0) {
				  callback(new Error('请选择房间'));
				} else {

				  callback();
				}
			  };
			return {
				downloadLoadin:false,
        user:{},
        getJZ:"",
        tableHeight:0,
				showPage:true,
				formInline: {
					currentPage: 1,
					pageSize: 10,
					username: "",
					meterPointName:"",
					phoneNumber: "",
          departmentId:'',
				},
        treeDate:[],
				userType:"1",
				editForm: {
					username: "",
					phoneNumber: "",
					appletUserType:"2",
					password: "123456",
					meterInfoIds: "",
          departmentId:'',
          isSendMsg:1
				},
				roomList: [],
				allRoomList:[],
				noBindRoomList:[],
				listData: [],
				selectDatas:[],
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				// rules表单验证
				rules: {
					username: [{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}],
					phoneNumber: [{
					  // pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
					  required: true,
					  message: '请输入正确的手机号',
					  trigger: 'blur'

					}],
					roomNum:[{validator:validatePass,trigger:'change' }]

				},
				title: "添加",
				editFormVisible: false,
				loadLoadin: false,
				loading: false,
				setLoading:false,

			}
		},
		components: {
			Pagination,
			PremsButton
		},
    mounted(){
      this.$nextTick(() => {

      	this.tableHeight = window.innerHeight - 300
      })
    },
		created(){
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.formInline.departmentId = this.user.departmentId
      this.editForm.departmentId = this.user.departmentId
      this.getJZ = this.user.departmentName
			this.getdata();
			this.getNoBindRoolist()


      this.getJzData();
			//this.getAllRoomList();
		},
		methods: {
			exportdata(){
				this.downloadLoadin = true

				let param = {
					username:this.formInline.username,
					meterPointName:this.formInline.meterPointName,
					phoneNumber:this.formInline.phoneNumber,
					type:""
				}
				poiAppletUserList(param).then(res => {
					var blob = new Blob([res], {type: 'application/vnd.openxmlformats-  officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
					var downloadElement = document.createElement('a');
				　　var href = window.URL.createObjectURL(blob); //创建下载的链接
				　　downloadElement.href = href;
				　　downloadElement.download = 'result.xls'; //下载后文件名
				　　document.body.appendChild(downloadElement);
				　　downloadElement.click(); //点击下载
				　　document.body.removeChild(downloadElement); //下载完成移除元素
				　　window.URL.revokeObjectURL(href); //释放掉blob对象
					this.downloadLoadin = false
					this.$message.success('表格生成成功！正在下载')
				}).catch(err => {
					this.downloadLoadin = false
					this.$message({
						message:'下载失败！',
						type:'error',
						showClose:true
					})
				})
			},
			handleSelectionChange() {

			},

      handleNodeClick(data){
        this.formInline.departmentId = data
        this.search()
      },

      //获取集中器信息
      getJzData:function(){
      	return new Promise((resolve,reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if(res.status == 1){
      				let arr = []
      				this.treeDate = res.data.menuDepList

      				resolve(res.data.terIds)
      			}
      			else{
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },


			importData(val) {
				this.loadLoadin = true
				console.log(val.file)
				let  formData = new FormData();
				formData.append('file', val.file);

				uploadAppletUser(formData).then(res => {
					this.loadLoadin = false
					if(res.status == 1){
						this.$message.success(res.msg)
						this.getdata();
					}else{
						this.$message.error(res.msg)
					}
				})
			},
			//显示编辑界面
			handleEdit: function(index, row) {
				this.editFormVisible = true
				if (row != undefined && row != 'undefined') {
					this.title = '修改'
					this.roomList = this.allRoomList
					this.editForm.id = row.id
					this.editForm.username = row.username
					this.editForm.phoneNumber = row.phoneNumber
					this.editForm.password = row.password
					this.editForm.appletUserType = row.appletUserType
          this.editForm.isSendMsg = row.isSendMsg
          this.editForm.departmentId = row.departmentId
					this.editForm.meterInfoIds = row.meterInfoVoList.map(item => item.id).join('-')
					this.selectDatas = row.meterInfoVoList.map(item => item.id)
					// console.log(this.selectDatas)
					// console.log(this.roomList)

				} else {
					this.title = '添加'
					this.roomList = this.noBindRoomList
					this.editForm.id = ""
					this.editForm.username = ""
					this.editForm.phoneNumber = ""
					this.editForm.password = ""
					this.editForm.meterInfoIds = ""
					this.editForm.appletUserType = '2'
          this.editForm.isSendMsg = 1
          this.editForm.departmentId = this.user.departmentId
					this.selectDatas = []

				}


				console.log(this.editForm.appletUserType)
			},
			// 编辑、增加页面保存方法
			submitForm(editData) {
				this.$refs[editData].validate(valid => {
					if (valid) {
						if (this.title == '添加') {
							this.add();
						} else {
							this.update();
						}
					} else {
						return false
					}
				})
			},
			onGetRoom(e){
				this.editForm.meterInfoIds = e.join('-')

			},

			// 关闭编辑、增加弹出框
			closeDialog() {
				this.editFormVisible = false
			},
			search() {
				this.pageparm.currentPage = 1
				this.formInline.currentPage = 1
				this.showPage = false

				this.getdata();
				 this.$nextTick(() => {
					this.showPage = true
				})
			},
			// 分页插件事件
			callFather(parm) {
				this.formInline.currentPage = parm.currentPage
				this.formInline.pageSize = parm.pageSize
				this.getdata(this.formInline)
			},

			getdata(){
				this.loading = true
				 appletUserList(this.formInline).then(res => {
				  this.loading = false
				  if (res.status == 1) {
						this.listData = res.data.data
						// 分页赋值
						this.pageparm.currentPage = this.formInline.currentPage
						this.pageparm.pageSize = this.formInline.pageSize
						this.pageparm.total = res.data.totalCount

				  } else {
				    this.$message({
				      type: 'info',
				      message: res.msg
				    })
				  }
				})
				.catch(err => {
				  this.editFormVisible = false
				  this.loading = false
				  this.$message.error('获取数据失败，请稍后再试！')
				})
			},

			getNoBindRoolist() {
				// findMybdMeterInfoList().then(res => {
				// 	if (res.status == 1) {
				// 		this.noBindRoomList = res.data
				// 	} else {
				// 		this.$message({
				// 			type: 'info',
				// 			message: res.msg
				// 		})
				// 	}
				// })
				// .catch(err => {
				// 	this.editFormVisible = false
				// 	this.loading = false
				// 	this.$message.error('获取房间数据失败，请稍后再试！')
				// })
			},

			getAllRoomList(){
				findAllMeterInfoList().then(res => {
					if (res.status == 1) {
						this.allRoomList = res.data
					} else {
						this.$message({
							type: 'info',
							message: res.msg
						})
					}
				})
				.catch(err => {
					this.editFormVisible = false
					this.loading = false
					this.$message.error('获取房间数据失败，请稍后再试！')
				})
			},

			add() {
				this.setLoading = true
				appletUserAdd(this.editForm)

					.then(res => {
						this.setLoading = false

						this.loading = false
						if (res.status == 1) {
              this.editFormVisible = false
							this.getdata()
							// this.$store.dispatch('getSendMsg')
							this.getNoBindRoolist()
							this.$message({
								type: 'success',
								message: '添加成功！'
							})
						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.editFormVisible = false
						this.setLoading = false
						this.$message.error('添加失败，请稍后再试！')
					})
			},
			update(){
				this.setLoading = true
				appletUserUpdate(this.editForm)
				  .then(res => {
					this.setLoading = false
				    this.editFormVisible = false
				    this.loading = false
				    if (res.status == 1) {

				      this.getdata()
					  // this.$store.dispatch('getSendMsg')
					  this.getNoBindRoolist()
				      this.$message({
				        type: 'success',
				        message: '操作成功！'
				      })
				    } else {
				      this.$message({
				        type: 'info',
				        message: res.msg
				      })
				    }
				  })
				  .catch(err => {
				    this.editFormVisible = false
				    this.setLoading = false
				    this.$message.error('操作失败，请稍后再试！')
				  })
			},

			 // 删除
			deleteInfo(index, row) {
			  this.$confirm('确定要删除吗?', '信息', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  })
			    .then(() => {
			      // 删除
			      appletUserDelete({ userId:row.id})
			        .then(res => {
			          if (res.status == 1) {
			            this.$message({
			              type: 'success',
			              message: '已删除!'
			            })
						this.getNoBindRoolist()
						// this.$store.dispatch('getSendMsg')
			            this.getdata()
			          } else {
			            this.$message({
			              type: 'info',
			              message: res.msg
			            })
			          }
			        })
			        .catch(err => {
			          this.loading = false
			          this.$message.error('删除失败，请稍后再试！')
			        })
			    })
			    .catch(() => {
			      this.$message({
			        type: 'info',
			        message: '已取消删除！'
			      })
			    })
			},
		},
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/prepayment/cuser.vue